import { render, staticRenderFns } from "./income-input.vue?vue&type=template&id=809ca8ca&scoped=true&"
import script from "./income-input.vue?vue&type=script&lang=js&"
export * from "./income-input.vue?vue&type=script&lang=js&"
import style0 from "./income-input.vue?vue&type=style&index=0&id=809ca8ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809ca8ca",
  null
  
)

export default component.exports